<ul class="tabs">
    <li class="tab" *ngFor="let tab of tabs">
        <a *ngIf="!autorouting"
           [class.active]="tab.active"
           (click)="tabClick(tab)">
            {{ tab.label | translate }}
        </a>

        <a *ngIf="autorouting"
           [routerLinkActive]="['active']"
           [routerLinkActiveOptions]="{exact: false}"
           [routerLink]="[autorouting ? tab.link : null]"
           [class.active]="tab.active"
           (click)="tabClick(tab)">
            {{ tab.label | translate }}
        </a>
    </li>
</ul>
